import { render, staticRenderFns } from "./PromoItem.vue?vue&type=template&id=32a9fa8e&scoped=true"
import script from "./PromoItem.vue?vue&type=script&lang=js"
export * from "./PromoItem.vue?vue&type=script&lang=js"
import style0 from "./PromoItem.vue?vue&type=style&index=0&id=32a9fa8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a9fa8e",
  null
  
)

export default component.exports